import React, { useState } from "react";
import { TypePaymentMethodEnum, typePaymentMethodLabels } from "./MasterDataTypes";

type PaymentMethodCheckboxListProps = {
    selectedStatuses: TypePaymentMethodEnum[];
    onChange: (statuses: TypePaymentMethodEnum[]) => void;
};

const PaymentMethodCheckboxList: React.FC<PaymentMethodCheckboxListProps> = ({ selectedStatuses, onChange }) => {
    const handleCheckboxChange = (status: TypePaymentMethodEnum) => {
        if (selectedStatuses.includes(status)) {
            onChange(selectedStatuses.filter((s) => s !== status));
        } else {
            onChange([...selectedStatuses, status]);
        }
    };

    return (
        <div style={{ display: "flex", gap: "10px" }}>
            {Object.values(TypePaymentMethodEnum).map((status) => (
                <label key={status} style={{ display: "flex", alignItems: "center" }}>
                    <input
                        type="checkbox"
                        checked={selectedStatuses.includes(status)}
                        onChange={() => handleCheckboxChange(status)}
                    />
                    <span style={{ marginLeft: "5px" }}>{typePaymentMethodLabels[status]}</span>
                </label>
            ))}
        </div>
    );
};

export default PaymentMethodCheckboxList;
